import React from 'react'

function DescargaEnExtra (props) {
  return (
    <></>
  )
}

export default DescargaEnExtra
